'use client';

import Image from 'next/image';
import { PROJECT_NAME } from '@shared/constants';

interface EmployerHeroSectionProps {
  onRequestDemo: () => void;
}

/**
 * @group Employers
 * @summary Hero section for employers page
 */
export function EmployerHeroSection({ onRequestDemo }: EmployerHeroSectionProps) {
  return (
    <section className="relative bg-hero-bg py-20 lg:py-32">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div>
            <h1 className="text-4xl lg:text-5xl font-bold text-hero-text mb-6">
              For Employers: Better Health, Better Business
            </h1>
            <p className="text-xl text-[#B8B4B0] mb-8 leading-relaxed">
              Forward-thinking South African employers are discovering that providing {PROJECT_NAME} as an employee benefit delivers measurable returns. Healthier employees mean reduced absenteeism, improved productivity, and a workforce that feels genuinely valued and supported.
            </p>
            <button
              onClick={onRequestDemo}
              className="px-8 py-4 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-primary/90 transition-colors shadow-lg hover:shadow-xl"
            >
              Request a Demo
            </button>
          </div>
          
          {/* Hero Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden max-h-[500px]">
              <Image
                src="/img/office.jpg"
                alt="Professional office environment"
                fill
                className="object-contain"
                priority
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
